/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type VerifyHarvestIntegrationInput = {
    harvestAccountName: string;
    harvestUserName: string;
    harvestPassword: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type verifyHarvestIntegrationMutationVariables = {
    input: VerifyHarvestIntegrationInput;
};
export type verifyHarvestIntegrationMutationResponse = {
    readonly verifyHarvestIntegration: {
        readonly success: boolean | null;
        readonly message: string | null;
        readonly company: {
            readonly id: string;
            readonly harvestEnabled: boolean | null;
            readonly harvestAccountName: string | null;
            readonly harvestUserName: string | null;
            readonly harvestPassword: string | null;
        } | null;
    } | null;
};
export type verifyHarvestIntegrationMutation = {
    readonly response: verifyHarvestIntegrationMutationResponse;
    readonly variables: verifyHarvestIntegrationMutationVariables;
};



/*
mutation verifyHarvestIntegrationMutation(
  $input: VerifyHarvestIntegrationInput!
) {
  verifyHarvestIntegration(input: $input) {
    success
    message
    company {
      id
      harvestEnabled
      harvestAccountName
      harvestUserName
      harvestPassword
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyHarvestIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyHarvestIntegrationPayload",
    "kind": "LinkedField",
    "name": "verifyHarvestIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUserName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestPassword",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyHarvestIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyHarvestIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "verifyHarvestIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation verifyHarvestIntegrationMutation(\n  $input: VerifyHarvestIntegrationInput!\n) {\n  verifyHarvestIntegration(input: $input) {\n    success\n    message\n    company {\n      id\n      harvestEnabled\n      harvestAccountName\n      harvestUserName\n      harvestPassword\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ed3c6b192ec368ec2d356a55fb4dabfc';
export default node;
